import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useDataSource } from '@bingads-webui-react/data-source';

import { I18n } from '../types';
import { useLoadingIndicatorStyles } from './loading-indicator-styles';

interface LoadingIndicatorProps {
  i18n: I18n;
  className?: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ i18n, className }) => {
  const classes = useLoadingIndicatorStyles();
  const { isLoading } = useDataSource();

  if (!isLoading) { return null; }

  return (
    <div className={mergeClasses('loading-indicator', classes.root, className)}>
      {i18n.getString(_TL_('Loading...'))}
    </div>
  );
};
